module.exports = __webpack_public_path__ + "img/info-safety.9019759e.svg";